<template>
  <div class="customer-service">
    <!-- 在线咨询按钮 -->
    <div class="service-btn consult-btn" @click="openConsult" v-if="config.consultUrl">
      <i class="el-icon-chat-line-round"></i>
      <span class="btn-text">在线咨询</span>
    </div>
    
    <!-- 客服微信按钮 -->
    <div class="service-btn wechat-btn" @mouseenter="showWechatQR = true" @mouseleave="showWechatQR = false" v-if="config.wechatQR">
      <i class="el-icon-chat-dot-round"></i>
      <span class="btn-text">客服微信</span>
      
      <!-- 微信二维码弹窗 -->
      <div class="wechat-qr-popup" v-show="showWechatQR">
        <div class="qr-content">
          <p class="qr-title">扫码添加客服微信</p>
          <img :src="getImageUrl(config.wechatQR)" alt="客服微信二维码" class="qr-image">
          <p class="qr-tip">长按识别二维码</p>
        </div>
        <div class="qr-arrow"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getServiceConfig } from '../api'
import { getImageUrl } from '../utils/image'

export default {
  name: 'CustomerService',
  data() {
    return {
      showWechatQR: false,
      config: {
        consultUrl: '',
        wechatQR: ''
      }
    }
  },
  async mounted() {
    await this.loadConfig()
  },
  methods: {
    getImageUrl,
    async loadConfig() {
      try {
        const res = await getServiceConfig()
        if (res.data) {
          this.config = res.data
        }
      } catch (error) {
        console.error('加载客服配置失败', error)
      }
    },
    openConsult() {
      if (this.config.consultUrl) {
        window.open(this.config.consultUrl, '_blank')
      }
    }
  }
}
</script>

<style scoped>
.customer-service {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.service-btn {
  width: 60px;
  height: 60px;
  background: linear-gradient(to top right, #172BE8 0%, #0AE8F8 100%);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(23, 43, 232, 0.4);
  transition: all 0.3s;
  position: relative;
  color: #fff;
  transform: translateY(0);
}

.service-btn:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 20px rgba(23, 43, 232, 0.6);
}

.service-btn i {
  font-size: 24px;
  margin-bottom: 4px;
}

.btn-text {
  font-size: 12px;
  line-height: 1;
}

.wechat-btn {
  background: linear-gradient(135deg, #409EFF 0%, #67C23A 100%);
  box-shadow: 0 4px 12px rgba(7, 193, 96, 0.4);
}

.wechat-btn:hover {
  box-shadow: 0 6px 20px rgba(64, 158, 255, 0.6);
}

/* 微信二维码弹窗 */
.wechat-qr-popup {
  position: absolute;
  right: 80px;
  bottom: 0;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  animation: fadeIn 0.3s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.qr-content {
  text-align: center;
}

.qr-title {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
}

.qr-image {
  width: 160px;
  height: auto;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  margin-bottom: 10px;
  display: block;
}

.qr-tip {
  font-size: 12px;
  color: #999;
  margin: 0;
}

.qr-arrow {
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #fff;
}

@media (max-width: 768px) {
  .customer-service {
    right: 10px;
    top: auto;
    bottom: 80px;
    transform: none;
    flex-direction: column;
    gap: 10px;
  }
  
  .service-btn {
    width: 50px;
    height: 50px;
  }
  
  .service-btn i {
    font-size: 20px;
  }
  
  .btn-text {
    font-size: 10px;
  }
  
  .wechat-qr-popup {
    right: 70px;
    bottom: 0;
    padding: 15px;
  }
  
  .qr-image {
    width: 120px;
    height: auto;
  }
}

@media (max-width: 480px) {
  .customer-service {
    right: 8px;
    bottom: 60px;
    gap: 8px;
  }
  
  .service-btn {
    width: 45px;
    height: 45px;
  }
  
  .service-btn i {
    font-size: 18px;
  }
  
  .btn-text {
    font-size: 9px;
  }
  
  .wechat-qr-popup {
    right: 60px;
    padding: 12px;
    min-width: 160px;
  }
  
  .qr-title {
    font-size: 12px;
    margin-bottom: 8px;
  }
  
  .qr-image {
    width: 100px;
  }
  
  .qr-tip {
    font-size: 11px;
  }
}
</style>

